<template>
    <div class="dragdrop-sm-wrapper">
        <div
            class="profile-upload-prompt"
            v-show="this.showUploadButton"
            @dragover="this.onDragOver"
            @dragleave="this.onDragLeave"
            @drop="this.onDrop">
            <div class="browse-btn-wrapper">
                <div class="bttn mb1 fluid secondary-hit mb-2 profile-upload-btn" @click="triggerUpload">
                    <input
                        type="file"
                        accept=".jpg, .png, .jpeg, .gif"
                        style="display: none;"
                        ref="input"
                        @change="this.onChange">
                    <iron-icon icon="nuskin:icon-profile"/>
                    {{txc.browse}}
                </div>
                <p class="helper-text" v-bind:class="{ 'error-text': this.imageTypeError }">
                    <span v-if="this.imageTypeError"> {{txcg.imageTypeError}}<br></span>{{txc.image_type}}
                    <br> {{txc.image_size}}
                </p>
            </div>

            <div class="dropTakeOver" v-if="showDropTakeover">
                <p>{{txc.file_drop}}</p>
            </div>
        </div>
        <div id="croppie-wrapper" v-show="this.showCroppie">
            <div class="icon-drawer">
                <iron-icon icon="nuskin:icon-close" @click="this.restartProcess"/>
                <template v-if="showRotateButton">
                    <iron-icon icon="nuskin:icon-rotate-right" class="rotate" @click="croppieInstance.rotate(-90)"/>
                    <iron-icon icon="nuskin:icon-rotate-left" class="rotate" @click="croppieInstance.rotate(90)"/>
                </template>
            </div>

            <div id="dragdrop-sm-cropper" ref="cropper" @update="this.croppieUpdate" style="border: none;"></div>
        </div>
    </div>
</template>

<script>
import Croppie from 'croppie';
import { mapGetters} from 'vuex';
export default {
    name: 'v-dragdrop-small',
    props: [],
    data () {
        return {
            showCroppie: false,
            showUploadButton: true,
            showDropTakeover: false,
            imageTypeError: false,
            reader: null,
            croppieInstance: null,
            showRotateButton: true,
            allowedTypes: 'image/jpg|image/jpeg|image/png|image/gif'
        }
    },
    computed : {
        ...mapGetters({
            txc: 'translationsPersonal',
            txcg: 'translationsGlobal',
            txce: 'translationsError'
        })
    },
    methods: {
        triggerUpload() {
            this.$refs.input.value = null;
            this.$refs.input.click();
        },
        clickFileInput() {
            this.$refs.imageInput.$children[0].$refs.input.click();
        },
        onChange (event) {
            let files = event.target.files;
            this.checkFileType(files);
        },
        onDragLeave (event) {
            event.preventDefault();
            event.stopPropagation();
            this.showDropTakeover = false;
        },
        onDragOver (event) {
            event.preventDefault();
            event.stopPropagation();
            this.showDropTakeover = true;
            this.imageTypeError = false;
        },
        onDrop (event) {
            event.preventDefault();
            this.showDropTakeover = false;
            if (!this.disabled) {
                let files = event.dataTransfer.files;
                this.checkFileType(files);
            }
        },
        checkFileType(files) {
            if (files && files[0].type.match(this.allowedTypes)) {
                this.uploadFiles(files);
            }else {
                this.imageTypeError = true;
            }
        },
        uploadFile (file) {
            this.reader = new FileReader()
            this.reader.addEventListener('loadend', () => {
                this.showImageEditor();
                this.initializeCroppie(this.reader.result);
            });
            this.reader.readAsDataURL(file);
        },
        uploadFiles (files) {
            if (files.length) {
                this.uploadFile(files[0]);
            }
        },
        initializeCroppie (image) {
            let url = image;
            let options = {
                url,
                viewport: { width: 200, height: 200, type: 'circle' },
                enforceBoundary: true,
                enableOrientation: true,
                customClass: 'imageCropper',
                mouseWheelZoom: 'ctrl'
            }
            let container = this.$refs.cropper;
            if (!container) return;
            this.croppieInstance = new Croppie(
                container,
                options
            );
            this.croppieInstance.bind({url: url, zoom: 1});
            this.showImageEditor();
        },
        croppieUpdate () {
            this.debounce(this.updateInput(), 250);
        },
        restartProcess () {
            this.hideImageEditor();
            this.croppieInstance.destroy();
            this.$emit('result', undefined);
        },
        showImageEditor () {
            this.showCroppie = true;
            this.showUploadButton = false;
        },
        hideImageEditor () {
            this.showCroppie = false;
            this.showUploadButton = true;
        },
        async updateInput () {
            let resultingImage = await this.croppieInstance.result({
                type: 'blob',
                size: { width: 200, height: 200 },
                quality: 1,
                circle: false
            });
            this.$emit('result', resultingImage);
        },
        debounce(func, wait, immediate) {
            //Credit to David Walsh
            //https://davidwalsh.name/javascript-debounce-function
            let timeout;
            return function() {
                // eslint-disable-next-line no-invalid-this
                let context = this, args = arguments;
                let later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },
        destroyAndCreateCroppie(profilePic) {
            if (this.croppieInstance) {
                try {
                    this.croppieInstance.destroy();
                } catch { /* TODO: */ }
            }

            if (profilePic !== 'NO PIC' || !!profilePic) {
                // Due to bug, if profilePic already exists, don't allow rotate
                this.showRotateButton = false;
                this.initializeCroppie(profilePic);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    .image-input-wrapper {
        display: flex;
        justify-content: center;
    }

    .browse-btn-wrapper {
        display:inline-block;
        text-align: center;
    }

    .profile-upload-prompt {
        padding: 68px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position:relative;
        color: rgba(100, 100, 100, .8); /* Pencil 80% */
    }

    .profile-upload-btn {
        padding: 25px 25px;
        border: 1px dashed var(--eyore);
        border-radius: 3px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        cursor: pointer;
        color: var(--shells);
    }

    .helper-text {
        color: var(--dryink);
        font-size: 14px;
    }

    .helper-text.error-text {
        color: var(--error);

        span {
            font-weight: 700;
        }
    }

    .profile-upload-prompt .dropTakeOver {
        width: 100%;
        height: 90%;
        position: absolute;
        top:5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: mix(white, #7123d9, 90%); /* Mermaid + 90% white (secondary hover color but not transparent) */
        border: 2px dashed var(--shells);
        border-radius: 3px;
        pointer-events: none;
    }

    .dropTakeOver p{
        color: var(--shells);
        font-size:1.5em;
        pointer-events: none;
    }

    .profile-upload-btn iron-icon {
        margin-bottom:5px;
    }

    #profile-image-uploader > div {
        background-color: red;
    }

    .v-card__actions {
        padding: 15px;
    }

    #croppie-wrapper {
        margin: 0 auto 30px;
        width:250px;
        height:250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        position: relative;

        .icon-drawer {
            display:flex;
            height:100px;
            flex-direction: column;
            justify-content: space-between;
            position: absolute;
            right: -20px;

            iron-icon {
                cursor: pointer;
            }
        }

        .cr-boundary {
            border-radius:5px;
        }
    }
</style>

// -------- CROPPIE styles
<style>
    .croppie-container {
        width: 100%;
        height: 100%;
    }

    .croppie-container .cr-image {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        transform-origin: 0 0;
        max-height: none;
        max-width: none;
    }

    .croppie-container .cr-boundary {
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        z-index: 1;
        width: 100%;
        height: 100%;
    }

    .croppie-container .cr-viewport,
    .croppie-container .cr-resizer {
        position: absolute;
        border: 2px solid #fff;
        margin: auto;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        box-shadow: 0 0 2000px 2000px rgba(0, 0, 0, 0.5);
        z-index: 0;
    }

    .croppie-container .cr-resizer {
        z-index: 2;
        box-shadow: none;
        pointer-events: none;
    }

    .croppie-container .cr-resizer-vertical,
    .croppie-container .cr-resizer-horisontal {
        position: absolute;
        pointer-events: all;
    }

    .croppie-container .cr-resizer-vertical::after,
    .croppie-container .cr-resizer-horisontal::after {
        display: block;
        position: absolute;
        /*box-sizing: border-box;
        border: 1px solid black;*/
        background: #fff;
        width: 10px;
        height: 10px;
        content: "";
    }

    .croppie-container .cr-resizer-vertical {
        bottom: -5px;
        cursor: row-resize;
        width: 100%;
        height: 10px;
    }

    .croppie-container .cr-resizer-vertical::after {
        left: 50%;
        margin-left: -5px;
    }

    .croppie-container .cr-resizer-horisontal {
        right: -5px;
        cursor: col-resize;
        width: 10px;
        height: 100%;
    }

    .croppie-container .cr-resizer-horisontal::after {
        top: 50%;
        margin-top: -5px;
    }

    .croppie-container .cr-original-image {
        display: none;
    }

    .croppie-container .cr-vp-circle {
        border-radius: 50%;
    }

    .croppie-container .cr-overlay {
        z-index: 1;
        position: absolute;
        cursor: move;
        touch-action: none;
    }

    .croppie-container .cr-slider-wrap {
        width: 75%;
        margin: 15px auto;
        text-align: center;
    }

    .croppie-result {
        position: relative;
        overflow: hidden;
    }

    .croppie-result img {
        position: absolute;
    }

    .croppie-container .cr-image,
    .croppie-container .cr-overlay,
    .croppie-container .cr-viewport {
        -webkit-transform: translateZ(0);
        -moz-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
    }

    /*************************************/
    /***** STYLING RANGE INPUT ***********/
    /*************************************/
    /*http://brennaobrien.com/blog/2014/05/style-input-type-range-in-every-browser.html */
    /*************************************/

    .cr-slider {
        -webkit-appearance: none;
        /*removes default webkit styles*/
        /*border: 1px solid white; */ /*fix for FF unable to apply focus style bug */
        width: 300px;
        /*required for proper track sizing in FF*/
        max-width: 100%;
        padding-top: 8px;
        padding-bottom: 8px;
        background-color: transparent;
        border:none;
    }

    .cr-slider::-webkit-slider-runnable-track {
        width: 100%;
        height: 3px;
        background: rgba(0, 0, 0, 0.5);
        border: 0;
        border-radius: 3px;
    }

    .cr-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: none;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        background: #ddd;
        margin-top: -6px;
    }

    .cr-slider:focus {
        outline: none;
        border:none;
        box-shadow:none;
    }
    /*
    .cr-slider:focus::-webkit-slider-runnable-track {
    background: #ccc;
    }
    */

    .cr-slider::-moz-range-track {
        width: 100%;
        height: 3px;
        background: rgba(0, 0, 0, 0.5);
        border: 0;
        border-radius: 3px;
    }

    .cr-slider::-moz-range-thumb {
        border: none;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        background: #ddd;
        margin-top: -6px;
    }

    /*hide the outline behind the border*/
    .cr-slider:-moz-focusring {
        outline: 1px solid white;
        outline-offset: -1px;
    }

    .cr-slider::-ms-track {
        width: 100%;
        height: 5px;
        background: transparent;
        /*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */
        border-color: transparent; /*leave room for the larger thumb to overflow with a transparent border */
        border-width: 6px 0;
        color: transparent; /*remove default tick marks*/
    }
    .cr-slider::-ms-fill-lower {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
    }
    .cr-slider::-ms-fill-upper {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
    }
    .cr-slider::-ms-thumb {
        border: none;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        background: #ddd;
        margin-top: 1px;
    }
    .cr-slider:focus::-ms-fill-lower {
        background: rgba(0, 0, 0, 0.5);
    }
    .cr-slider:focus::-ms-fill-upper {
        background: rgba(0, 0, 0, 0.5);
    }
    /*******************************************/

    /***********************************/
    /* Rotation Tools */
    /***********************************/
    .cr-rotate-controls {
        position: absolute;
        bottom: 5px;
        left: 5px;
        z-index: 1;
    }
    .cr-rotate-controls button {
        border: 0;
        background: none;
    }
    .cr-rotate-controls i:before {
        display: inline-block;
        font-style: normal;
        font-weight: 900;
        font-size: 22px;
    }
    .cr-rotate-l i:before {
        content: "↺";
    }
    .cr-rotate-r i:before {
        content: "↻";
    }
</style>
